export default {
    LANGUAGE_SET: 'LANGUAGE::SET'
};



// WEBPACK FOOTER //
// ./src/store/language/LanguageActionsEnums.js